import { t } from 'ttag';

import { useViewedProducts } from '@hook/useViewedProducts';
import { LayoutContainer } from '@ui/LayoutContainer';
import { Title } from '@ui/Title';
import { ViewedProductsContainer } from '@containers/ViewedProducts';

import s from './ViewedProductsMainSection.sss';

export const ViewedProductsMainSection = () => {
  const { viewedProductsIds } = useViewedProducts();

  if (viewedProductsIds.length) {
    return (
      (
        <LayoutContainer>
          <section className={s.section}>
            <Title
              className={s.title}
              type="h3"
              bold={false}
            >
              {t`Ви також переглядали`}
            </Title>

            <div className={s.products}>
              <ViewedProductsContainer maxCount={30} />
            </div>
          </section>
        </LayoutContainer>
      )
    );
  }

  return null;
};
